<template>
  <a-modal
    title="Dodaj harmonogram"
    width="60vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    okText="Zapisz"
    cancelText="Anuluj"
  >
    <form-wrapper
      ref="form"
      :service="CoursePayment"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      @formSubmitted="success"
    >
      <inner-form
        v-for="(singleForm, i) in form"
        :key="i"
        :value="singleForm"
        :errors="errors[i] || {}"
        :with-remove-icon="form.length > 1"
        @delete="removeFormsetItem(singleForm)"
        @input="newValue => updateFormItem(i, newValue)"
        @submit="onSubmit"
      />
    </form-wrapper>

    <a-button type="link" icon="plus" @click="addFormsetItem"
      >dodaj płatność</a-button
    >
  </a-modal>
</template>

<script>
import InnerForm from './CoursePaymentForm'
import { CoursePayment } from '@/api'

export default {
  data() {
    return {
      visible: false,
      student: null,
      course: null,
      form: [],
      errors: [],
      CoursePayment,
      InnerForm
    }
  },
  components: {
    InnerForm
  },
  methods: {
    updateFormItem(i, newValue) {
      this.$set(this.form, i, newValue)
    },
    onSubmit() {
      this.$refs.form.onSubmit()
    },
    removeFormsetItem(item) {
      const index = this.form.indexOf(item)
      if (index > -1) {
        this.form.splice(index, 1)
      }
    },
    addFormsetItem() {
      // use if you make formset
      const blankObject = this.getBlankObject()
      if (this.form === undefined) {
        this.form = [blankObject]
      } else {
        this.form = [...this.form, blankObject]
      }
    },
    getBlankObject() {
      return {
        course: this.course,
        student: this.student
      }
    },
    openModal(courseId) {
      this.student = this.$route.params.studentId
      this.course = courseId
      this.addFormsetItem()
      this.visible = true
    },
    success() {
      this.closeModal()
      this.$emit('formSubmitted')
    },
    closeModal() {
      this.resetForm()
      this.visible = false
    },
    resetForm() {
      this.form = []
      this.errors = []
    }
  }
}
</script>
